// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__15Tuw","orders":"style_orders__kufCn"};